const awsmobile = {
    "aws_project_region": "us-east-1",
    "region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ay8dypcaA",
    "aws_user_pools_web_client_id": "2gqr8eh0vcmg40q4oqsnikq2ee",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "region": "us-east-1"
};

export default awsmobile;


/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// const awsmobile = {
//     "aws_project_region": "us-east-1",
//     "aws_cognito_region": "us-east-1",
//     "aws_user_pools_id": "us-east-1_IdqbhzRQd",
//     "aws_user_pools_web_client_id": "3jplsff2ecu9b824rd2rdac10k",
//     "oauth": {},
//     "aws_cognito_username_attributes": [
//         "EMAIL"
//     ],
//     "aws_cognito_social_providers": [],
//     "aws_cognito_signup_attributes": [
//         "EMAIL"
//     ],
//     "aws_cognito_mfa_configuration": "OFF",
//     "aws_cognito_mfa_types": [
//         "SMS"
//     ],
//     "aws_cognito_password_protection_settings": {
//         "passwordPolicyMinLength": 8,
//         "passwordPolicyCharacters": []
//     },
//     "aws_cognito_verification_mechanisms": [
//         "EMAIL"
//     ]
// };

// export default awsmobile;